import {useQuery} from "@tanstack/react-query";
import {queryKeys} from "../react-query/constant";
import {DashboardApi} from "../api/DashboardApi";


export const useDashboardData = () => {
    return useQuery(
        [queryKeys.dashboard],
        ()=>DashboardApi()
    )

}